import React, { useState } from 'react'
import {
  Dialog,
  DialogContent,
  DialogActions,
  TextField,
  InputAdornment,
  Typography,
  Fade,
} from '@material-ui/core'
import {
  Button,
  Loader,
  FullscreenExitButton,
  FullscreenDialogTitle,
} from 'sputnik-ui'
import config from 'config'
import styled from "styled-components";

const StyledLink = styled.a`
  color: #007bff;
  text-decoration: none;
  &:hover {
    text-decoration: underline;
  }
`;

const Transition = (props) => <Fade in={true} {...props} />

const DocInvoiceModal = ({ open, onClose }) => {
  const [amount, setAmount] = useState('')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)
  const [pdfUrl, setPdfUrl] = useState(null)

  const handleClose = () => {
    if (pdfUrl) URL.revokeObjectURL(pdfUrl)
    setPdfUrl(null)
    setAmount('')
    setError(null)
    onClose()
  }

  const handleGenerate = async () => {
    setLoading(true)
    setError(null)
    try {
      const response = await fetch(`${config.baseUri}/billing/invoices`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ amount: parseInt(amount, 10) }),
      })
      if (!response.ok) {
        const data = await response.json()
        throw new Error(data.message || 'Не удалось создать счёт')
      }
      const blob = await response.blob()
      setPdfUrl(URL.createObjectURL(blob))
    } catch (err) {
      setError(err.message || 'Не удалось создать счёт. Попробуйте снова.')
    } finally {
      setLoading(false)
    }
  }

  const ContactInfo = () => (
  <Typography variant="body2" color="text.secondary" style={{ marginTop: "8px" }}>
    E-mail: <StyledLink href="mailto:sales@sputnik.systems">sales@sputnik.systems</StyledLink>
    <br />
    Телеграм-бот: <StyledLink href="https://t.me/sputnik_sales_bot">@sputnik_sales_bot</StyledLink>
    <br />
    Телефон: <StyledLink href="tel:88005115232">8 800 511-52-32</StyledLink>
  </Typography>
);
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      TransitionComponent={Transition}
      fullScreen
    >
      <FullscreenExitButton onClick={handleClose} />
      <FullscreenDialogTitle>Выставить счёт</FullscreenDialogTitle>

      {!pdfUrl ? (
        <>
          <DialogContent style={{ display: 'flex', justifyContent: 'center' }}>
            <div
              style={{
                maxWidth: 400,
                width: '100%',
                marginTop: '2rem',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
              }}
            >
              <TextField
                fullWidth
                label="Сумма"
                type="number"
                value={amount}
                onChange={(e) => setAmount(e.target.value)}
                autoFocus
                inputProps={{ min: 1, step: 1 }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">₽</InputAdornment>
                  ),
                }}
              />

              {error && (
                <Typography
                  color="error"
                  variant="body2"
                  style={{ marginTop: '1rem' }}
                >
                  {error}
                </Typography>
              )}

              <Typography
                variant="body2"
                align="center"
                style={{
                  marginTop: '1.5rem',
                  maxWidth: 360, // prevents touching sides
                  lineHeight: 1.5,
                }}
              >
                Денежные средства будут зачислены на баланс Личного кабинета в течение 24 часов после оплаты.
                В случае возникновения вопросов обратитесь в Коммерческий отдел Спутника. <br />
                Контакты:
              </Typography>
              <ContactInfo />
            </div>
          </DialogContent>
          <DialogActions style={{ justifyContent: 'center', margin: '1.325rem' }}>
            <Button
              rounded
              primary
              size="fullScreen"
              variant="contained"
              onClick={handleGenerate}
              disabled={!amount || loading}
            >
              Сформировать счёт
            </Button>
          </DialogActions>
        </>
      ) : (
        <iframe
          src={pdfUrl}
          title="Счёт на оплату"
          style={{ flex: 1, border: 'none', width: '100%' }}
        />
      )}

      {loading && (
        <Loader
          msg="Формируем счёт..."
          style={{
            position: 'absolute',
            background: 'rgba(0,0,0,0.65)',
            color: 'white',
          }}
          textProps={{ variant: 'h5' }}
        />
      )}
    </Dialog>
  )
}

export default DocInvoiceModal
